// @flow

import React from 'react';
import { string } from 'prop-types';
import { FormattedMessage } from 'react-intl';

type HasType = {
    type: string,
};

export const checkboxLabel = (
    <FormattedMessage
        id="shareModal.checkbox.label"
        defaultMessage="Allow recipient to see your notes"
    />
);

export const HeaderTitle = ({ type }: HasType) => (
    <FormattedMessage
        id="shareModal.header"
        defaultMessage={`
            {type, select,
                CATALOG {Email This Catalog}
                ITEMS {Share Items}
                FOLDERS {Share Folder}
                INVOICE {Share Invoice}
                DESIGN_PROFILE {Contact Designer}
                other {Email This Item}
            }
        `}
        values={{ type }}
    />
);

HeaderTitle.propTypes = {
    type: string.isRequired,
};

export const SubmitLabel = ({ type }: HasType) => (
    <FormattedMessage
        id="shareModal.submit"
        defaultMessage={`
            {type, select,
                ITEMS {Share Items}
                FOLDERS {Share Folder}
                INVOICE {Share}
                DESIGN_PROFILE {Send}
                other {Send}
            }
        `}
        values={{ type }}
    />
);

SubmitLabel.propTypes = {
    type: string.isRequired,
};
